var Handlebars = require("../../../../../node_modules/.pnpm/handlebars@4.7.10/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"0":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      <div class=\"item\">\n        <span class=\"leaflet-popup-label\">"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"qtt") : depth0), depth0))
    + "</span>\n        <span class=\"leaflet-popup-text\">"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"name") : depth0), depth0))
    + "</span>\n      </div>\n";
},"1":function(container,depth0,helpers,partials,data) {
    return "      <div class=\"item\">...</div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.escapeExpression, alias3=container.lambda, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"leaflet-popup-body\">\n  <div class=\"leaflet-popup-header\">"
    + alias2(__default(require("./i18n.js")).call(alias1,"Common.FarmMachine",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":2,"column":36},"end":{"line":2,"column":65}}}))
    + "</div>\n  <div class=\"leaflet-popup-fuel-station\">\n"
    + ((stack1 = lookupProperty(helpers,"each").call(alias1,(depth0 != null ? lookupProperty(depth0,"brands") : depth0),{"name":"each","hash":{},"fn":container.program(0, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":4,"column":4},"end":{"line":9,"column":13}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"wrap") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":10,"column":4},"end":{"line":12,"column":11}}})) != null ? stack1 : "")
    + "  </div>\n  <div class=\"leaflet-popup-evaluation\">\n    <div class=\"col-xs-6\">\n      <div class=\"leaflet-popup-evaluation-title\">"
    + alias2(__default(require("./i18n.js")).call(alias1,"Common.Brands",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":16,"column":50},"end":{"line":16,"column":74}}}))
    + "</div>\n      <div class=\"leaflet-popup-evaluation-value\">"
    + alias2(alias3((depth0 != null ? lookupProperty(depth0,"totalBrands") : depth0), depth0))
    + "</div>\n    </div>\n    <div class=\"col-xs-6\">\n      <div class=\"leaflet-popup-evaluation-title\">"
    + alias2(__default(require("./i18n.js")).call(alias1,"Common.FarmMachine",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":20,"column":50},"end":{"line":20,"column":79}}}))
    + "</div>\n      <div class=\"leaflet-popup-evaluation-value\">"
    + alias2(alias3((depth0 != null ? lookupProperty(depth0,"totalFarmMachines") : depth0), depth0))
    + "</div>\n    </div>\n  </div>\n</div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/scripts/core/templates/templates/map-layer-farm-machine-cluster-popup.hbs
// module id = l0qE
// module chunks = 1